export default "__VITE_ASSET__O9vPSTNG__"